<template>
    <div class="container-fluid">  
        <div class="row justify-content-center">
            <div class="col-md-10">
                <h3 class="my-3">Dashboard</h3>   
            </div>    
        </div>    
        <div class="row justify-content-around">
            <div class="col-md-10">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body border-left-danger  pt-5">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <p class="header-text">AFCFTA NUMBER</p>
                                        <P class=""><span>{{currentUser.individual.afcfta_number}}</span><span style="float:right; color:#ba2428;"><i class="fas fa-band-aid fa-3x"></i></span></P>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-6">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="card">
                            <div class="card-body border-left-danger pt-5">
                                <p class="header-text">FINAL AFCFTA NUMBER</p>
                                 <P> <span>{{currentUser.final_afcfta_number ? currentUser.organisation.final_afcfta_number : 'Not Available'}}</span> <span style="float:right;color: #ba2428;"><i class="fas fa-receipt fa-3x"></i></span></P>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>  
    </div>
</template>
<script>
import Storage from '../helpers/storage'
export default {
    data() {
        return {
            name:null,
            api:null,
            success:null,
            error:null,
            allow:null
        }
    },
    methods: {

    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser
        }
    },
    
}
</script>
<style scoped>
    .card{
        height: 250px;
    }
    .header-text{
        color:black;
        font-weight: bolder;
        font-size: 1.5em;
    }
</style>